<script lang="ts">
    import SubField from "./SubField.svelte"

    export let field: TaskStepField<"object">,
        fullPath: string,
        value: any = {}
</script>

<div class="object">
    {#if field.label}
        <h3>{field.label}:</h3>
    {/if}
    <div class="grid">
        {#each field.subFields || [] as subField}
            <div class="field {subField.size ? subField.size : 'col-12'} field-{subField.widget}">
                <SubField
                    subField="{subField}"
                    fullPath="{fullPath}"
                    bind:value="{value}"
                />
            </div>
        {/each}
    </div>
</div>

<style lang="less">
    .object {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        h3 {
            color: var(--text-100);
            font-size: 0.8rem;
            font-weight: 400;
        }
    }
</style>
